import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('modalSignup', ['setSignupModalOpen']),

    openModal() {
      this.setSignupModalOpen(true)
    },
  },
}
